export function getRoleValue(roleLike) {
  if (!roleLike) return null;
  if (typeof roleLike === "string") return roleLike;
  return roleLike.rol || roleLike.detalle || null;
}

export function getDefaultRole(user) {
  return getRoleValue(user?.rolDefault);
}

export function getModuleRole(user, key) {
  return getRoleValue(user?.[key]);
}

export function userHasAnyRole(user, roles) {
  if (!roles || roles.length === 0) return true;
  return roles.includes(getDefaultRole(user));
}

export function userIsDistribuidor(user) {
  return getDefaultRole(user) === "Distribuidor";
}

export function userIsVisualizador(user) {
  return getDefaultRole(user) === "Visualizador";
}

export function userIsAccesoMercado(user) {
  return getDefaultRole(user) === "AccesoMercado";
}

export function userIsCobranzas(user) {
  return getDefaultRole(user) === "Cobranzas";
}

const performanceModules = ["rolClientes", "rolCYO", "rolPOG", "rolCC"];

export function userIsPerformance(user) {
  if (!user) return false;

  return performanceModules.some(
    (apiKey) => getModuleRole(user, apiKey) === "Performance",
  );
}

const NOVEDAD_DELETE_ALLOWED_EMAILS = new Set([
  "ana-karen.spioussas@basf.com",
  "maria-ana.laguzzi@basf.com",
  "gustavo.saldania@basf.com",
  "jeronimo.carmody-fernandez@basf.com",
]);

export function canDeleteNovedadByEmail(email) {
  return NOVEDAD_DELETE_ALLOWED_EMAILS.has(email?.toLowerCase());
}

const moduleRoleMap = {
  micuenta: "rolClientes",
  mialta: "rolClientes",
  mi_alta: "rolClientes",
  mitienda: "rolClientes",
  weboficial: "rolClientes",
  cyo: "rolCYO",
  mispedidos: "rolPedidos",
  pedidos: "rolPedidos",
  cc: "rolCC",
  pog: "rolPOG",
  simulador: "rolPlanComercial",
  planes: "rolPlanComercial",
};

export function getRoleByModule(module, user) {
  const roleKey = moduleRoleMap[module];
  if (!roleKey) return "-";

  return getModuleRole(user, roleKey) ?? "-";
}
